import { Line } from "@ant-design/plots"
import { Skeleton } from "../../common"

const LineChart = ({ loading, disabled, ...config }) => {
  return loading ? (
    <div style={{ marginTop: 20 }}>
      <Skeleton type="input" width={500} height={300} active />
    </div>
  ) : (
    <Line
      legend={{ position: "top" }}
      smooth
      animation={{ appear: { animation: "path-in", duration: 1000 } }}
      style={disabled ? { pointerEvents: "none", opacity: 0.7 } : undefined}
      {...config}
    />
  )
}
export default LineChart
